<template>
  <div :class="['view-on-bandcamp']">
    <a :href="href" rel="noreferrer" target="_blank" :title="$lang.viewOnBadcamp" :class="[`${$config.colors.primary}--text`]" v-html="$lang.viewOnBadcamp" />
  </div>
</template>
<script>
export default {
  name: 'ViewOnBandcamp',
  props: {
    href: {
      type: String,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view-on-bandcamp.vue